import { makeAutoObservable, runInAction } from 'mobx';
import services from "../services";
import { extractErrorMessage } from "../utils/helpers";
import { generateCreteEntity, generateDeleteEntity, generateLoadEntity } from "../utils/mobx";
import keyBy from "lodash/keyBy";
import compact from "lodash/compact";
import createEnrollMember from "../forms/enrollMember";
import createBillingInfoForm from "../forms/enrollBillingInfo";
import createBillingAddressForm from "../forms/billingAddress";
import { common } from "@material-ui/core/colors";
import {STARFISH_KIT_EN_SKU, STARFISH_KIT_ES_SKU, STARFISH_KIT_FR_SKU} from "../utils/constants";
const permanentItems = ["enroll01", "eLifeAppSuperPlus"];
function canDeleteAdapter(cart) {
    if (!cart) return;
    // let items = Array.isArray(cart) ? cart : cart.cartItems;
    // if (items)
    //     items.forEach(x => {
    //         x.canDelete = !permanentItems.find(y=>  x.productSKU.startsWith(y));
    //     });

    return cart;

}

function combineItemsWithRecomendations(cart, additionalItems, occurrence, supportInfo, t) {
    let items = cart ? cart.cartItems.filter(x => x.productSKU !== "eRenew01" && x.productSKU !== "eRenew02" && x.occurrence === occurrence) : [];
    let recommended = additionalItems ? additionalItems.filter(x => x.occurrence === occurrence && x.recommended) : [];

    recommended.forEach(x => {
        let existing = items.find(i => x.productSKU === i.productSKU);
        if (!existing) {
            x.removed = x.productSKU !== "enroll01";
            x.canDelete = x.productSKU !== "enroll01";
            if( !x.totalCost ){
                try {
                    //parse cost from productPrice field
                    let costMatch = /(\d+(?:[\.\,]\d{2})?)$/.exec(  x.productPrice)
                    x.totalCost = costMatch && parseFloat(costMatch[1]);
                }
                catch (e){}

            }
            x.totalTCs = x.productTC;

            items.unshift(x);
        }
    });
    const enroll = items.find( x => x.productSKU === "enroll01") || recommended.find( x => x.productSKU === "enroll01") ;
    let starfish = cart && cart.cartItems?  cart.cartItems.find( x => x.productSKU.startsWith('eLifeAppSuperPlus')) : null;
    if ( !starfish ){
        starfish =  recommended.find( x => x.productSKU.startsWith('eLifeAppSuperPlus'))
    }

    const haveBookkit = supportInfo?.isUserBoughtBookKits
    if ( enroll)
    {
        if (haveBookkit) {
            console.log(enroll)
            enroll.canDelete = false;
            enroll.removed = starfish ? !starfish.removed: false;
            enroll.canAdd = false;
            enroll.customPrice = t("enrollmember:enrollwaived", {price: enroll.totalCost} )
        } else {

        }
    }

    if (  starfish )
    {
        starfish.canDelete = true;

    }




    return items;
}

class MemberEnrollmentStore {
    constructor(userBillingInfoStore, authStore, commonStore, supportStore ) {
        makeAutoObservable(this);
        this.userBillingInfoStore = userBillingInfoStore;
        this.authStore = authStore;
        this.commonStore = commonStore;
        this.supportStore = supportStore;
    }

    error = null;
    cartError = null;
    additionalItems = null;
    loadingReferralInfo = false;
    loadingAdditionalItems = false;
    loadingCartInfo = false;
    loadingCartTotals = false;
    addingItemToCart = false;
    addingItemsToCart = [];
    creating = false;
    removingItemToCart=[]
    cart = null;
    totals = null;
    expired = false;
    activeStep = "1";
    paymentID = 0;
    signature = [];

    billingInfoForm = null;
    billingInfoFormSubmitting = false;

    personalForm = null;
    personalFormSubmitting = false;

    billingInfoFormEdit = null;
    billingInfoFormEditSubmitting = false;

    billingAddressForm = null;
    billingAddressFormSubmitting = false;

    billingAddressFormEdit = null;
    billingAddressFormEditSubmitting = false;
    t = null;

    removedItems = [];

    addRestorable(item){
        this.removedItems.push(item);
    }

    async initPersonalInfoForm(country) {
        this.personalForm = createEnrollMember(country
            , {
                onSuccess: () => { runInAction(() => { this.personalFormSubmitting = false; this.handleNextStep(); }); },
                onError: () => { runInAction(() => { this.personalFormSubmitting = false; }); }
            });
    }

    initBillingInfoForm() {

        let country = this.authStore.currentUser.address && this.authStore.currentUser.address.country;
        this.billingInfoForm = createBillingInfoForm({
            paymentID: 0,
            billCountry: country,
            billFirstName: this.authStore.currentUser.firstName,
            billLastName: this.authStore.currentUser.lastName
        }, {
            onSuccess: () => { runInAction(() => { this.billingInfoFormSubmitting = false; this.handleNextStep(); }); },
            onError: () => { runInAction(() => { this.billingInfoFormSubmitting = false; }); }
        });
    }

    async initBillingInfoFormEdit(onSuccess) {
        this.billingInfoFormEdit = createBillingInfoForm({}
            , {
                onSuccess: () => {
                    runInAction(() => {
                        this.billingInfoFormEditSubmitting = false;
                        onSuccess();
                    });
                },
                onError: () => { runInAction(() => { this.billingInfoFormEditSubmitting = false; }); }
                ,
            });
    }

    initBillingAddressFormEdit(onSuccess) {
        this.billingAddressFormEdit = createBillingAddressForm({ ...this.billingAddressForm.values() }
            , {
                onSuccess: () => {
                    this.billingAddressFormEditSubmitting = false;
                    if (this.billingAddressFormEdit)
                        this.billingAddressForm.update(this.billingAddressFormEdit.values());
                    onSuccess();
                },
                onError: () => { this.billingAddressFormEditSubmitting = false; }
                ,
            });
    }


    submitPersonalForm() {
        this.personalFormSubmitting = true;
        this.personalForm.submit();
    }

    submitBillingInfoForm() {
        if (this.paymentID > 0 || this.paymentID === "ewallet") {
            this.handleNextStep();
            this.billingInfoForm.clear();
            this.billingInfoForm.reset();
        }
        else {

            this.billingInfoFormSubmitting = true;
            this.billingInfoForm.submit();
        }
    }
    submitBillingInfoEditForm() {
        this.billingInfoFormEditSubmitting = true;
        this.billingInfoFormEdit.submit();
    }
    submitBillingAddressForm() {
        this.billingAddressFormSubmitting = true;
        this.billingAddressForm.submit();
    }
    submitBillingAddressEditForm() {
        this.billingAddressFormEditSubmitting = true;
        this.billingAddressFormEdit.submit();
    }

    closeBillingInfoFormEdit() {
        this.billingInfoFormEdit = null;
    }

    closeBillingAddressFormEdit() {
        this.billingAddressFormEdit = null;
    }


    get pages() {

        return {
            "1": "memberagreement",
            "2": "compensationandprocedures",
            "3": "personalinfo",
            "4": "billinginfo",
            "5": "summary"
        };
    }

    setTranslation(t){
        this.t = t;
    }

    get oneTimeItems() {
        return combineItemsWithRecomendations(this.cart, this.additionalItems, "onetime", this.supportStore.supportInfo, this.t);
    }

    get recurringItems() {
        return combineItemsWithRecomendations(this.cart, this.additionalItems, "recurring", this.supportStore.supportInfo, this.t );
    }

    get cartTotal() {
        return this.totals && this.totals[0].cartTotal;
    }

    get effectiveAdditionalItems() {
        if (!this.cart || !this.additionalItems) return [];
        let existing = keyBy([...this.oneTimeItems, ...this.recurringItems], "productSKU");
        return this.additionalItems.filter(x => !existing[x.productSKU] && x.productSKU !== "eRenew01" && x.productSKU !== "eRenew02" && x.productSKU !== "eLifeAppSuperPlusDis");

    }

    get renewPrice() {
        if (!this.cart) return 0;
        let p = this.cart.cartItems.find(x => x.productSKU === "eRenew01");
        return p && p.productPrice;
    }

    get renewDiscount() {
        if (!this.cart) return 0;
        let p = this.cart.cartItems.find(x => x.productSKU === "eRenew02");
        return p && p.productPrice;
    }

    resetCart() {
        //this.cart = null
        //this.totals = null
    }
    setError(error, type = "series") {
        error = extractErrorMessage(error);
        if (error && type === "verify") {
            this.expired = true;
        }
        else if (error && type === "addToCart") {
            this.cartError = error;
        }
        else
            this.error = error;
    }

    setActiveStep(activeStep) {
        this.activeStep = activeStep;
    }

    setPaymentId(newVal) {
        this.paymentID = newVal;
    }

    setSignature(newVal) {
        this.signature = newVal;
    }

    handleNextStep() {
        let maxPage = Object.keys(this.pages).length;
        let step = Math.min(maxPage, Number(this.activeStep) + 1);

        // if ( step === 5  && this.paymentID > 0 )
        //     step = Math.min(maxPage, step + 1);
        this.setActiveStep(step.toString());
    }

    handlPrevStep() {
        let step = Math.max(1, Number(this.activeStep) - 1);

        //if ( step === 5  && this.paymentID > 0 )
        //    step = Math.max(1, step - 1);

        this.setActiveStep(step.toString());
    }


    verify = generateLoadEntity("verify", this, "loadingReferralInfo"
        , (loginGuid) => { return services.MemberEnrollment.verify(loginGuid); }, "referralInfo");


    loadCart = generateLoadEntity("loadCart", this, "loadingCartInfo"
        , ({ product, language, country }) => {
            return services.MemberEnrollment.cart(product, language);
        }, "cart", null, canDeleteAdapter);

    loadCartTotal = generateLoadEntity("loadCartTotals", this, "loadingCartTotals"
        , ({ cartID, lang }) => {
            return services.MemberEnrollment.cartTotal(cartID, lang);
        }, "totals");


    loadAdditionalItems = generateLoadEntity("loadAdditionalItems", this, "loadingAdditionalItems"
        , ({ country, lang }) => { return services.MemberEnrollment.additionalItems(country, lang); }
        , "additionalItems"
        , null, (result) => compact(result));


    addToCart = generateCreteEntity("addToCart", this, "addingItemToCart"
        , async (params) => {
            this.addingItemsToCart.push(params.productID);
            try {
                const res = await services.MemberEnrollment.addItemToCart(params);
                const item = this.removedItems.find(x => x.productID === params.productID);
                this.removedItems.remove(item);
                return res
            }
            finally {
                this.addingItemsToCart.remove(params.productID);
            }
    });

    removeFromCart = generateDeleteEntity("removeItemFromCart", this, "removingItemToCart"
        , async (key, params) => {
          const result = await  services.MemberEnrollment.removeItemFromCart(params);
            return result;
    });


    create = generateCreteEntity("create", this, "creating"
        , (params) => { return services.MemberEnrollment.create(params); });


    refreshItems = generateLoadEntity("refreshItems", this, "loadingCartInfo"
        , ({ cartID, country, lang }) => { return services.MemberEnrollment.loadItems(cartID, lang); }
        , (result) => {
            if (this.cart) {
                if (this.cart.cartItems)
                    this.cart.cartItems.replace(result);
                else
                    this.cart.cartItems = result;
            }
        }, null, canDeleteAdapter);

    createShopCheckout = generateCreteEntity("createShopCheckout", this, "creating"
        , (params) => { return services.ShoppingCart.checkout(params); }, null, { throwError: true });

    async updateItemsByBookkit(){
        //logic by having Bookkit in past purchases
        const haveBookkit = this.supportStore.supportInfo?.isUserBoughtBookKits
        let country = this.authStore.currentUser.address && this.authStore.currentUser.address.country;

        if ( haveBookkit ){
            if (this.cart) {
                const enroll = this.cart.cartItems.find( x => x.productSKU === "enroll01");
                const starfish = this.cart.cartItems.find( x => x.productSKU.startsWith('eLifeAppSuperPlus'));
                //if ( starfish  && !starfish.removed)
                //    await this.removeFromCart(enroll.productID,{ cartID: this.cart.cartID, productID: enroll.productID, lang: this.commonStore.language });
                //await this.refreshItems({ cartID: this.cart.cartID, country, lang: this.commonStore.language });
            }

        }
        else {

        }

    }

}

export default MemberEnrollmentStore;